import { SettingsResponse } from '../client/settings-api'

const SETTINGS_CACHE_KEY = 'settings-cache'

// "Hide spoilers" setting: when on, unwatched episodes of a show the user
// started render blurred (still + overview) until marked as watched.
export const hideSpoilers = (): boolean => {
  try {
    const cached = localStorage.getItem(SETTINGS_CACHE_KEY)
    if (!cached) return true
    const parsed = JSON.parse(cached) as SettingsResponse
    return parsed.spoilerControl ?? true
  } catch {
    return true
  }
}

export default hideSpoilers
